import LocationDistances from "../components/LocationDistances";
import PlansGrid from "../components/PlansGrid";
import ProjectsGrid from "../components/ProjectsGrid";
import MainSlider from "../components/MainSlider";
import Slider from "../components/Slider";
import CatalogDownload from "../components/CatalogDownload";

import image1 from "../assets/img/urla/1/f2.jpg";
import image2 from "../assets/img/urla/1/f1g.jpg";
import image3 from "../assets/img/urla/1/f6.jpg";
import image4 from "../assets/img/urla/1/f7.jpg";

import plan1t from '../assets/img/urla/2/plan1.jpg';
import plan2t from '../assets/img/urla/2/f2v.jpg';
import plan3t from '../assets/img/urla/2/plan2.jpg';
import plan4t from '../assets/img/urla/2/plan3.jpg';

import image5 from "../assets/img/parkbirebir/birebir.jpg";
import image6 from "../assets/img/green/gp1.jpg";
import image7 from "../assets/img/karsiyaka/kg1.jpg";
import image8 from "../assets/img/bornova/b1.jpg";


import catalogBg from "../assets/img/urla/1/f10.jpg";

import slides1 from "../assets/img/urla/1/f1.jpg";
import slides2 from "../assets/img/urla/1/f2.jpg";
import slides3 from "../assets/img/urla/1/f6.jpg";
import slides4 from "../assets/img/urla/1/f5.jpg";
import Banner from "../components/Banner";

import logo from "../assets/img/urla/logo-urla.png";

const slidesData = [
    {
        titleLines: ["Doğayla İç İçe, Nefes Alan Yaşam Alanları", "Urla Green"],
        image: slides1,
        alt: "Doğayla İç İçe, Nefes Alan Yaşam Alanları Urla Green",
        link: "projects/urla"
    },
    {
        titleLines: ["Zarif ve Eşsiz Mimari Detaylarıyla", "Urla Green"],
        image: slides2,
        alt: "Zarif ve Eşsiz Mimari Detaylarıyla Urla Green",
        link: "projects/urla"
    },
    {
        titleLines: ["Yemyeşil ve Ferah Terasıyla Güne Huzurlu Bir Başlangıç Yapmak İçin", "Urla Green"],
        image: slides3,
        alt: "Yemyeşil ve Ferah Terasıyla Güne Huzurlu Bir Başlangıç Yapmak İçin Urla Green",
        link: "projects/urla"
    },
    {
        titleLines: ["Bahçenizde Günü Karşıladığınız Sakin ve Keyifli Anlar İçin", "Urla Green"],
        image: slides4,
        alt: "Bahçenizde Günü Karşıladığınız Sakin ve Keyifli Anlar İçin Urla Green",
        link: "projects/urla"
    },
];
const projects = [
    { id: 2, image: image6, title: "Green Park", subtitle: "(Satış Devam Ediyor)", link: "/projects/green-park" },
    { id: 3, image: image7, title: "Karşıyaka Green", subtitle: "", link: "/projects/karsiyaka-green" },
    { id: 4, image: image8, title: "Bornova Green", subtitle: "", link: "/projects/bornova-green" },
    { id: 1, image: image5, title: "Park Birebir Hayat", subtitle: "", link: "#" }
];
const points = [
    { name: "İzmir Golf Kulübü", distance: "0.1km" },
    { name: "Göztepe Yelken Kulübü", distance: "2.4 km" },
    { name: "Çeşme Otoban", distance: "4 km" },
    { name: "İskele", distance: "8.1 km" },
    { name: "İYTE", distance: "10.7 km" },
    { name: "Urla Devlet Hastanesi", distance: "4.2 km" },
    { name: "TED Koleji", distance: "14.2 km" },
    { name: "Karaburun Otoban Çıkışı", distance: "3 dk" },
    { name: "Urla Otoban Çıkışı", distance: "10 dk" },
    { name: "Çeşme - Alaçatı", distance: "15 dk" },
    { name: "Adnan Menderes Havalimanı", distance: "40 dk" },
];
const images = [
    { thumb: image1, full: image1 },
    { thumb: image3, full: image3 },
    { thumb: image2, full: image2 },
    { thumb: image4, full: image4 }
];
const plans = [
    { img: plan1t, alt: "Plan 1", caption: "" },
    { img: plan2t, alt: "Plan 2", caption: "" },
    { img: plan3t, alt: "Plan 3", caption: "" },
    { img: plan4t, alt: "Plan 4", caption: "" }
];
const badges = [
    // {
    //     content: (
    //         <>
    //             <div style={{ fontWeight: 700, fontSize: "1.8rem" }}>Aralık</div>
    //             <div style={{ fontWeight: 900, fontSize: "2.4rem" }}>2026</div>
    //             <div style={{ fontWeight: 700, fontSize: "1.8rem" }}>Teslim</div>
    //         </>
    //     ),
    // },
    {
        content: (
            <>
                <div style={{ fontWeight: 900, fontSize: "1.8rem" }}>Cazip</div>
                <div style={{ fontWeight: 700, fontSize: "2.4rem" }}>Ödeme</div>
                <div style={{ fontWeight: 900, fontSize: "1.8rem" }}>Fırsatları</div>
            </>
        ),
    }
];
const banner = {
    subtitle: "Doğayla İç İçe, Nefes Alan",
    title: "Urla Green'de Yaşam Başlıyor...",
    desc: "Detaylarıyla büyüleyen yaşam alanları, ferah ve yemyeşil bahçeleriyle huzurlu bir yaşam sunuyor.",
    logoSrc: logo
};

export default function HomePage() {
    document.title = `HCP Yapı - Urla Green`;

    return (
        <>
            <MainSlider slidesData={slidesData} badges={badges} />
            <Banner {...banner} />
            <LocationDistances locationSrc="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3130.5069765159046!2d26.716116076774345!3d38.31408918090956!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzjCsDE4JzUwLjciTiAyNsKwNDMnMDcuMyJF!5e0!3m2!1str!2str!4v1750678781038!5m2!1str!2str" points={points} highlightBlockProps={{ bgLabel: "Urla Green", calligraphy: "Proje Hakkında" }} />
            <Slider items={images} />
            <PlansGrid plans={plans} desc="56.500 m2 lik arsa üzerine kurulu 22 adet müstakil villada yeni hayatlarınız, sizleri bekliyor." highlightBlockProps={{ bgLabel: "Urla Green", calligraphy: "Vaziyet Planı" }} />
            <CatalogDownload
                pdfUrl="/docs/Urla-Green-Katalog.pdf"
                bgImage={catalogBg}
                title="Kataloğumuza göz atmak ister misiniz?"
            />
            <ProjectsGrid projects={projects} highlightBlockProps={{ bgLabel: "Projeler", calligraphy: "Tamamlanan Projeler" }} />
        </>
    );
}
